import { Directive, HostListener, ElementRef, Input, OnChanges, SimpleChanges, SimpleChange, Renderer2 } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { FormlyFieldConfig } from './formly.field.config';
export class FormlyAttributes implements OnChanges {
   field: FormlyFieldConfig;
   formControl: AbstractControl;
private attributes = ['id', 'name', 'placeholder', 'tabindex', 'step', 'aria-describedby'];
private statements = ['change', 'keydown', 'keyup', 'keypress', 'click', 'focus', 'blur'];
/**
 * @return {?}
 */
onFocus() {
    this.field.focus = true;
  }
/**
 * @return {?}
 */
onBlur() {
    this.field.focus = false;
  }
/**
 * @param {?} renderer
 * @param {?} elementRef
 */
constructor(
private renderer: Renderer2,
private elementRef: ElementRef,
  ) {}
/**
 * @param {?} changes
 * @return {?}
 */
ngOnChanges(changes: SimpleChanges) {
    if (changes.field) {
      const /** @type {?} */ fieldChanges = changes.field;
      this.attributes
        .filter(attr => this.canApplyRender(fieldChanges, attr))
        .map(attr => this.renderer.setAttribute(
          this.elementRef.nativeElement, attr, this.getPropValue(this.field, attr),
        ));

      this.statements
        .filter(statement => this.canApplyRender(fieldChanges, statement))
        .map(statement => this.renderer.listen(
          this.elementRef.nativeElement, statement, this.getStatementValue(statement),
        ));

      if ((fieldChanges.previousValue || {}).focus !== (fieldChanges.currentValue || {}).focus && this.elementRef.nativeElement.focus) {
        this.elementRef.nativeElement[this.field.focus ? 'focus' : 'blur']();
      }
    }
  }
/**
 * @param {?} field
 * @param {?} prop
 * @return {?}
 */
private getPropValue(field: FormlyFieldConfig, prop: string) {
    field = field || {};
    if (field.id && prop === 'aria-describedby') {
      return field.id + '-message';
    }

    if (field.templateOptions && field.templateOptions[prop]) {
      return field.templateOptions[prop];
    }

    return field[prop] || '';
  }
/**
 * @param {?} statement
 * @return {?}
 */
private getStatementValue(statement: string) {
    const /** @type {?} */ fn = this.field.templateOptions[statement];

    return () => fn(this.field, this.formControl);
  }
/**
 * @param {?} fieldChange
 * @param {?} prop
 * @return {?}
 */
private canApplyRender(fieldChange: SimpleChange, prop: string): Boolean {
    const /** @type {?} */ currentValue = this.getPropValue(this.field, prop), /** @type {?} */
      previousValue = this.getPropValue(fieldChange.previousValue, prop);

    if (previousValue !== currentValue) {
      if (this.statements.indexOf(prop) !== -1) {
        return typeof currentValue === 'function';
      }

      return true;
    }

    return false;
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[formlyAttributes]',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer2, },
{type: ElementRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'field': [{ type: Input, args: ['formlyAttributes', ] },],
'formControl': [{ type: Input },],
'onFocus': [{ type: HostListener, args: ['focus', ] },],
'onBlur': [{ type: HostListener, args: ['blur', ] },],
};
}

function FormlyAttributes_tsickle_Closure_declarations() {
/** @type {?} */
FormlyAttributes.decorators;
/**
 * @nocollapse
 * @type {?}
 */
FormlyAttributes.ctorParameters;
/** @type {?} */
FormlyAttributes.propDecorators;
/** @type {?} */
FormlyAttributes.prototype.field;
/** @type {?} */
FormlyAttributes.prototype.formControl;
/** @type {?} */
FormlyAttributes.prototype.attributes;
/** @type {?} */
FormlyAttributes.prototype.statements;
/** @type {?} */
FormlyAttributes.prototype.renderer;
/** @type {?} */
FormlyAttributes.prototype.elementRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
